export const Editor = {
    toolbars: {
        full: [
            'undo',
            'redo',
            '|',
            'insertLink',
            'awareMedia',
            'insertVideo',
            'embedly',
            'insertFile',
            'insertTable',
            '|',
            'specialCharacters',
            'insertHR',
            'selectAll',
            'clearFormatting',
            '|',
            'print',
            'spellChecker',
            'html',
            '-',
            'bold',
            'italic',
            'underline',
            'strikeThrough',
            '|',
            'fontSize',
            'paragraphFormat',
            'align',
            'formatOL',
            'formatUL',
            'outdent',
            'indent',
            'quote',
            'color',
        ],
        slim: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'insertLink', 'insertImage', 'clearFormatting', '|', 'html'],
        'ultra-slim': ['undo', 'redo', '|', 'insertLink', 'clearFormatting'],
    },
};
